import TeacherPage from "./teacherPage"

export default TeacherPage;